<template v-cloak>
    <div class="pg010Main" id="wrapper"> 
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <div v-if="pg010MainRequest.pageNo == 1"><message/></div>

        <div class="header mb32 margin-auto" v-cloak>
            <message v-if="pg010MainRequest.pageNo == 3"/>
            <template v-for="(item, index) in pg010MainInit.list">
                <component v-if="item.WAKU_ID == 1" :key="index"
                    :is="item.PART_NM"
                    :partsNo="item.EC_PARTS_NO"
                    :ptInitData="item.INIT_DATA"
                    :ptPageNo="ptPageNo"
                    :ptPageSize="ptPageSize"
                    :ptOrderByType="ptOrderByType"
                    @event-loading="getLoading"
                    @evt-change-quantily="getChangeQtyFlg"
                    :evtChangeQtyFlg="changeQtyFlg">
                </component>
            </template>
        </div>

        <div id="contents" v-cloak v-if="pg010MainRequest.pageNo == 1">
            <div id="contents-inner">
                <div :id="idLeft" v-if="((wakuptno == '1') || (wakuptno == '2'))" v-cloak>
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 2" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
                <div :id="idCenter" v-cloak>
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 3" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
                <template v-if="wakuptno == '1'" v-cloak>
                    <div id="screen3sub-contents-right">
                        <template v-for="(item, index) in pg010MainInit.list" >
                            <component v-if="item.WAKU_ID == 4" :key="index"
                                :is="item.PART_NM"
                                :partsNo="item.EC_PARTS_NO"
                                :ptInitData="item.INIT_DATA"
                                :ptPageNo="ptPageNo"
                                :ptPageSize="ptPageSize"
                                :ptOrderByType="ptOrderByType"
                                @event-loading="getLoading"
                                @evt-change-quantily="getChangeQtyFlg"
                                :evtChangeQtyFlg="changeQtyFlg">
                            </component>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div id="contents" v-else-if="pg010MainRequest.pageNo == 2">
            <div id="contents-inner">
                <div id="screen2sub-contents" v-if="((wakuptno == '1') || (wakuptno == '2'))">
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 2" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
                <div id="screen2main-contents">
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 3" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
            </div>
        </div>
        <div id="contents" v-else-if="pg010MainRequest.pageNo == 3">
            <div id="contents-inner">
                <div id="screen2sub-contents" v-if="((wakuptno == '1') || (wakuptno == '2'))">
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 2" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
                <div id="screen2main-contents">
                    <template v-for="(item, index) in pg010MainInit.list" >
                        <component v-if="item.WAKU_ID == 3" :key="index"
                            :is="item.PART_NM"
                            :partsNo="item.EC_PARTS_NO"
                            :ptInitData="item.INIT_DATA"
                            :ptPageNo="ptPageNo"
                            :ptPageSize="ptPageSize"
                            :ptOrderByType="ptOrderByType"
                            @event-loading="getLoading"
                            @evt-change-quantily="getChangeQtyFlg"
                            :evtChangeQtyFlg="changeQtyFlg">
                        </component>
                    </template>
                </div>
            </div>
        </div>
        <div id="contents" v-else>
            <div id="contents-inner">
                <template v-if="getLengthObj(pg010MainInit.list) > 0" >
                    <template v-if="pg010MainInit.list[0].WAKU_PTN_NO == 2 || pg010MainInit.list[0].WAKU_PTN_NO == 1 ">
                        <div id="screen2sub-contents">
                            <template v-for="(item, index) in pg010MainInit.list" >
                                <component v-if="item.WAKU_ID == 2" :key="index"
                                    :is="item.PART_NM"
                                    :partsNo="item.EC_PARTS_NO"
                                    :ptInitData="item.INIT_DATA"
                                    :ptPageNo="ptPageNo"
                                    :ptPageSize="ptPageSize"
                                    :ptOrderByType="ptOrderByType"
                                    @event-loading="getLoading"
                                    @evt-change-quantily="getChangeQtyFlg"
                                    :evtChangeQtyFlg="changeQtyFlg">
                                </component>
                            </template>
                        </div>
                    </template>
                    
                    <div :id="idCenter">
                        <template v-for="(item, index) in pg010MainInit.list" >
                            <component v-if="item.WAKU_ID == 3" :key="index"
                                :is="item.PART_NM"
                                :partsNo="item.EC_PARTS_NO"
                                :ptInitData="item.INIT_DATA"
                                :ptPageNo="ptPageNo"
                                :ptPageSize="ptPageSize"
                                :ptOrderByType="ptOrderByType"
                                @event-loading="getLoading"
                                @evt-change-quantily="getChangeQtyFlg"
                                :evtChangeQtyFlg="changeQtyFlg">
                            </component>
                        </template>
                    </div>

                    <template v-if="pg010MainInit.list[0].WAKU_PTN_NO == 1">
                        <div id="screen3sub-contents-right" >
                            <template v-for="(item, index) in pg010MainInit.list" >
                                <component v-if="item.WAKU_ID == 4" :key="index"
                                    :is="item.PART_NM"
                                    :partsNo="item.EC_PARTS_NO"
                                    :ptInitData="item.INIT_DATA"
                                    :ptPageNo="ptPageNo"
                                    :ptPageSize="ptPageSize"
                                    :ptOrderByType="ptOrderByType"
                                    @event-loading="getLoading"
                                    @evt-change-quantily="getChangeQtyFlg"
                                    :evtChangeQtyFlg="changeQtyFlg">
                                </component>
                            </template>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <!--トップに戻る-->
        <p v-if="topShow" class="pagetop" ref="pagetop" @click="scrollTop" style="display: block"><a><span>TOP</span></a></p>

        <div class="footer" v-cloak>
            <div class="footer-inner">
                <template v-for="(item, index) in pg010MainInit.list" >
                    <component v-if="item.WAKU_ID == 5" :key="index" 
                        :is="item.PART_NM"
                        :partsNo="item.EC_PARTS_NO"
                        :ptInitData="item.INIT_DATA"
                        :ptPageNo="ptPageNo" 
                        :ptPageSize="ptPageSize" 
                        :ptOrderByType="ptOrderByType"
                        @event-loading="getLoading"
                        @evt-change-quantily="getChangeQtyFlg"
                        :evtChangeQtyFlg="changeQtyFlg">
                    </component>
                </template>
            </div>
        </div>

        <CP001 v-if="showCP001Flg" :newCouponCnt="newCouponCnt"  @data-selected="setDataTk020"></CP001>
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import $ from "jquery";
import common from "assets/js/common";
import Message from 'components/Message';
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import SiteConstants from 'assets/const/SiteConstants.json';
import Vue from 'vue';
import VueMeta from 'vue-meta';

import PT010GrobalMenuParts from "../parts/PT010GrobalMenuParts";
import PT030ProductSearchParts from "../parts/PT030ProductSearchParts";
import PT035ProductAllergenSearchParts from "../parts/PT035ProductAllergenSearchParts";
import PT041CategoryShowParts from "../parts/PT041CategoryShowParts";
import PT050ShoppingCartParts from "../parts/PT050ShoppingCartParts";
import PT055SoryoFreeLineParts from "../parts/PT055SoryoFreeLineParts";
import PT060LoginParts from "../parts/PT060LoginParts";
import PT070RankingParts from "../parts/PT070RankingParts";
import PT080CategoryHeadlineParts from "../parts/PT080CategoryHeadlineParts";
import PT090InformationParts from "../parts/PT090InformationParts";
import PT090InformationPartDetail from "../parts/PT090InformationPartDetail";
import PT110ProductListParts from "../parts/PT110ProductListParts";
import PT115TokuProductListParts from "../parts/PT115TokuProductListParts";
import PT120ProductDetailsParts from "../parts/PT120ProductDetailsParts";
import PT150BannerHtmlParts from "../parts/PT150BannerHtmlParts";
import PT151HtmlNoEditParts from "../parts/PT151HtmlNoEditParts";
import PT152OriginalParts from "../parts/PT152OriginalParts";
import PT160ChangePassword from "../parts/PT160ChangePassword";
import PT180ShopperCartShowParts from "../parts/PT180ShopperCartShowParts";
import PT200QuickOrderParts from "../parts/PT200QuickOrderParts";
import PT210ChukyoMultiOrderParts from "../parts/PT210ChukyoMultiOrderParts";
import PT300RelationParts from "../parts/PT300RelationParts";
import PT310OtherParts from "../parts/PT310OtherParts";
import PT320CheckParts from "../parts/PT320CheckParts";
import PT330QmailParts from "../parts/PT330QmailParts";
import PT350PasswordSendAgain from "../parts/PT350PasswordSendAgain";
import PT360SecretQuestion from "../parts/PT360SecretQuestion";
import PT395MemberMyPageParts from "../parts/PT395MemberMyPageParts";
import PT400MemberInfoParts from "../parts/PT400MemberInfoParts";
import PT402CreditChangeParts from "../parts/PT402CreditChangeParts";
import PT403PassWordChangeParts from "../parts/PT403PassWordChangeParts";
import PT405MemberInfoTdkParts from "../parts/PT405MemberInfoTdkParts";
import PT410MemberTdkDetailsParts from "../parts/PT410MemberTdkDetailsParts";
import PT415MemberQuotationListParts from "../parts/PT415MemberQuotationListParts";
import PT420MemberDeleteParts from "../parts/PT420MemberDeleteParts";
import PT425MemberBillListParts from "../parts/PT425MemberBillListParts";
import PT430MemberOrderHisParts from "../parts/PT430MemberOrderHisParts";
import PT431MemberOrderPayChangeParts from "../parts/PT431MemberOrderPayChangeParts";
import PT435MemberSendListParts from "../parts/PT435MemberSendListParts";
import PT436MemberSendDetParts from "../parts/PT436MemberSendDetParts";
import PT440Favourite from "../parts/PT440Favourite";
import PT460MemberOrderHisDetParts from "../parts/PT460MemberOrderHisDetParts";
import PT461ItemReviewParts from "../parts/PT461ItemReviewParts";
import PT462ItemReviewListParts from "../parts/PT462ItemReviewListParts";
import PT470ProductSearchDetailsParts from "../parts/PT470ProductSearchDetailsParts";
import PT480MemberPointDetParts from "../parts/PT480MemberPointDetParts";
import PT482MemberRankDisplayParts from "../parts/PT482MemberRankDisplayParts";
import PT485MemberCouponListParts from "../parts/PT485MemberCouponListParts";
import PT510OrderItemParts from "../parts/PT510OrderItemParts";
import PT401MemberInfoCompleteParts from "../parts/PT401MemberInfoCompleteParts";
import PT600FirstAccessMailParts from "../parts/PT600FirstAccessMailParts";
import PT610FirstAccessMenberInfoParts from "../parts/PT610FirstAccessMenberInfoParts";
import PT620DairiOrderHisParts from "../parts/PT620DairiOrderHisParts";
import PT630DairiOrderHisDetParts from "../parts/PT630DairiOrderHisDetParts";
import TK001TeikiListParts from "../parts/TK001TeikiListParts";
import TK010TeikiDetailParts from "../parts/TK010TeikiDetailParts";
import TK035TeikiIkkatuListParts from "../parts/TK035TeikiIkkatuListParts";
import TK036TeikiIkkatuDetailParts from "../parts/TK036TeikiIkkatuDetailParts";
import PT640OrderChangeBannerHtmlParts from "../parts/PT640OrderChangeBannerHtmlParts";
import SH070ShopperComplete from "../shopper/SH070ShopperComplete";

import SH011ShopperLogin from "../shopper/SH011ShopperLogin";
import SH030ShopperTdkInfo from "../shopper/SH030ShopperTdkInfo";
import SH040ShopperTdkInfoGift from "../shopper/SH040ShopperTdkInfoGift";
import SH041ShopperTdkInfoSetting from "../shopper/SH041ShopperTdkInfoSetting";
import SH050ShopperPayDetails from "../shopper/SH050ShopperPayDetails";
import SH051ShopperPointDetails from "../shopper/SH051ShopperPointDetails";
import SH060ShopperInfoConfirm from "../shopper/SH060ShopperInfoConfirm";
import SH061ShopperItemInfoNoshi from "../shopper/SH061ShopperItemInfoNoshi";
import CP001 from '../popup/CP001Popup.vue';
import SH062ShopperMatomeItemInfo from "../shopper/SH062ShopperMatomeItemInfo";
import PT035ProductAllergenSearchPartsVue from '../parts/PT035ProductAllergenSearchParts.vue';

Vue.use(VueMeta);

export default {
    name: "PG010MainPage",
    components: {
        Loading,
        PT010GrobalMenuParts,
        PT030ProductSearchParts,
        PT035ProductAllergenSearchParts,
        PT041CategoryShowParts,
        PT050ShoppingCartParts,
        PT055SoryoFreeLineParts,
        PT060LoginParts,
        PT070RankingParts,
        PT080CategoryHeadlineParts,
        PT090InformationParts,
        PT090InformationPartDetail,
        PT110ProductListParts,
        PT115TokuProductListParts,
        PT120ProductDetailsParts,
        PT150BannerHtmlParts,
        PT151HtmlNoEditParts,
        PT152OriginalParts,
        PT160ChangePassword,
        PT180ShopperCartShowParts,
        PT200QuickOrderParts,
        PT210ChukyoMultiOrderParts,
        PT300RelationParts,
        PT310OtherParts,
        PT320CheckParts,
        PT330QmailParts,
        PT350PasswordSendAgain,
        PT360SecretQuestion,
        PT395MemberMyPageParts,
        PT400MemberInfoParts,
        PT401MemberInfoCompleteParts,
        PT402CreditChangeParts,
        PT403PassWordChangeParts,
        PT405MemberInfoTdkParts,
        PT410MemberTdkDetailsParts,
        PT415MemberQuotationListParts,
        PT420MemberDeleteParts,
        PT425MemberBillListParts,
        PT430MemberOrderHisParts,
        PT431MemberOrderPayChangeParts,
        PT435MemberSendListParts,
        PT436MemberSendDetParts,
        PT440Favourite,
        PT460MemberOrderHisDetParts,
        PT461ItemReviewParts,
        PT462ItemReviewListParts,
        PT470ProductSearchDetailsParts,
        PT480MemberPointDetParts,
        PT485MemberCouponListParts,
        PT482MemberRankDisplayParts,
        PT510OrderItemParts,
        PT600FirstAccessMailParts,
        PT610FirstAccessMenberInfoParts,
        PT620DairiOrderHisParts,
        PT630DairiOrderHisDetParts,
        TK001TeikiListParts,
        TK010TeikiDetailParts,
        TK035TeikiIkkatuListParts,
        TK036TeikiIkkatuDetailParts,
        PT640OrderChangeBannerHtmlParts,
        
        SH011ShopperLogin,
        SH030ShopperTdkInfo,
        SH040ShopperTdkInfoGift,
        SH041ShopperTdkInfoSetting,
        SH050ShopperPayDetails,
        SH051ShopperPointDetails,
        SH060ShopperInfoConfirm,
        SH061ShopperItemInfoNoshi,
        SH062ShopperMatomeItemInfo,
        SH070ShopperComplete,
        CP001,
        Message,
        PT250FAQTopParts: () => import("../parts/PT250FAQTopParts"),
        PT255FAQListParts: () => import("../parts/PT255FAQListParts"),
        PT260FAQContentParts: () => import("../parts/PT260FAQContentParts"),
    },
    data: function() {
        return {
            ptPageNo: null,
            ptPageSize: null,
            ptOrderByType: null,
            pg010MainCss:{
                titleNm: null,
                siteText: null,
                siteTag: null,
                pgColor: null,
                linkColor: null,
                overLinkColor: null,
                pgImg: null,
                keyWords: '',
            },
            linkColor:null,
            overLinkColor:null,
            pg010MainRequest:{},
            pg010MainInit:{
                list:[]
            },
            wakuptno: null,
            isLoading: false,
            changeQtyFlg: false,
            idCenter:null,
            idLeft:null,
            topShow: false,

            SiteConstants: SiteConstants,
            site: "",
            scrolled: 0,
            showCP001Flg: false,
            newCouponCnt: 0,
        }
    },
    metaInfo() {
        return {
            title: this.pg010MainCss.titleNm,
            meta: [
                {name: 'title', content: this.pg010MainCss.titleNm},
                {name: 'description', content: this.pg010MainCss.siteText},
                {name: 'keywords', content: this.pg010MainCss.keyWords}
            ]
        };
    },
    mounted: async function() {
        var _this = this;

        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        //Call API init
        _this.isLoading = true;
        
        await _this.getPageNo();
        
        let requestBack = null;
        if (_this.pg010MainRequest.requestBack){
            requestBack = _this.pg010MainRequest.requestBack;
            _this.pg010MainRequest.requestBack = null;
        }

        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PG010MAIN + _this.$UrlConstants.DO_INIT, _this.pg010MainRequest).then(function(response) {
            console.log(response.data);
            if (response.data.isMypage == false){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 1}});
                return;
            }

            if (response.data.isExpiredPassword) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.SiteConstants.CHANGE_PASSWORD_PAGE}});
                return;
            }

            _this.pg010MainInit.list = response.data.list;
            _this.pg010MainInit.commonData = response.data.commonData;
            if (_this.pg010MainRequest.pageNo != 1 && _this.pg010MainRequest.pageNo != 2 && _this.pg010MainRequest.pageNo != 3){
                _this.pg010MainRequest = response.data.reqModel;
            }
            

            if (_this.pg010MainRequest.pageNo){
                if(_this.pg010MainInit.list != undefined && _this.pg010MainInit.list.length > 0) {
                    _this.wakuptno = _this.pg010MainInit.list[0].WAKU_PTN_NO;
                }
            }

            common.setCssPage(_this.pg010MainCss , response.data);

            if (_this.pg010MainRequest.pageNo != 2 && _this.pg010MainRequest.pageNo != 3){
                if (_this.pg010MainInit.list[0].WAKU_PTN_NO == '1' ){
                    _this.idCenter="screen3main-contents";
                    if (_this.pg010MainRequest.pageNo == 1){
                        _this.idLeft="screen3sub-contents-left";
                    }                   
                }
                else if (_this.pg010MainInit.list[0].WAKU_PTN_NO == '2'){
                    _this.idCenter="screen2main-contents";
                    if (_this.pg010MainRequest.pageNo == 1){
                        _this.idLeft="screen2sub-contents";
                    }   
                }
                else {
                    _this.idCenter="screen1main-contents";
                }
            }

            _this.isLoading = false;

            if (!response.data.isCustomerGroupSetting) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 8}});
                return;
            }

            if (!response.data.isCompAndBusyoSetting) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 8}});
                return;
            }

            _this.scrollHash();

            if (response.data.logined){
                _this.showCouponPopup();
            }
        }).catch(function(error) {
            _this.isLoading = false;
            if(error != null && error != undefined){
                if(error.response != null && error.response != undefined){
                    if(406 == error.response.status){
                        var listId = common.excuteValidation(error);
                        _this.listIdErr.push.apply(_this.listIdErr, listId);
                        common.scrollTop();
                    }else{
                        common.errorAPI(error);
                    }
                }
            }
        });

    },
    methods: {
         showCouponPopup: function(){
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.CP001 + _this.$UrlConstants.DO_INIT, _this.pg010MainRequest).then(function(response) {
                if(response.data.isLogin == true && response.data.newCouponCnt > 0 && sessionStorage.getItem('COUPON_POPUP_FLG')== null){
                    _this.showCP001Flg = true;
                    _this.newCouponCnt = response.data.newCouponCnt;
                    
                    _this.updCouponKidoku();
                } else {
                    _this.showCP001Flg = false;
                    _this.newCouponCnt = 0;
                } 
                if (response.data.isLogin == true) {
                    sessionStorage.setItem('COUPON_POPUP_FLG', '1');
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },
        updCouponKidoku: function(){
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.CP001 + _this.$UrlConstants.DO_UPDATE, _this.pg010MainRequest).then(function() {
                
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },
        /**
         * get status loading
         * @param {Boolean} val, true || false
         */
        getLoading: function(val){
            var _this = this;
            _this.isLoading = val;

        },
        /**
         * get event change quantily
         */
        getChangeQtyFlg: function(){
           this.changeQtyFlg = !this.changeQtyFlg;
        },
        /**
        * Get length obj
        * @param {object} obj, obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * handle Scroll on page
         */
        handleScroll: function() {
            window.scrollY || window.pageYOffset > 100 ? this.topShow = true : this.topShow = false;
        },
        /**
         * scroll top
         */
        scrollTop: function(){
            $('body, html').animate({ scrollTop: 0 }, 500);
        },	
        getPageNo: async function(){
            var _this = this;
            //Call API insert
            if (_this.pg010MainRequest.customUrl != null || _this.pg010MainRequest.customUrl != undefined) {
                await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PG010MAIN + _this.$UrlConstants.DO_SEARCH, _this.pg010MainRequest).then(function(response) {
                    _this.pg010MainRequest = Object.assign(_this.pg010MainRequest, response.data.reqModel);
                    if (_this.pg010MainRequest.pageNo == null || _this.pg010MainRequest.pageNo == undefined ) {
                        if (_this.pg010MainRequest.customPageNo == null || _this.pg010MainRequest.customPageNo == undefined) {
                            _this.$router.push({name: "NotFound" });
                        }
                    }
                    
                }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                });
            }
        },
        setDataTk020: function(){
            var _this = this;
            _this.showCP001Flg = false;
        },
        scrollHash(){
            //ページ内リンク
            if(window.location.hash != ''){
                var hashDom = document.getElementById(window.location.hash.replace('#',''));
                if(hashDom){
                    hashDom.scrollIntoView();
                    this.scrolled = 10;
                    console.log(this.scrolled);
                }

                if(this.scrolled < 10){
                    this.scrolled = this.scrolled + 1;
                    setTimeout(() => {
                        this.scrollHash();
                    },500);
                } 
            }
        }
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
        var _this =this;
        //Get param from router when contructor this.
        var queryData = _this.$route.query;
        var params = _this.$route.params;
        if(Object.keys(queryData).length > 0){
            _this.pg010MainRequest = Object.assign({}, _this.pg010MainRequest, queryData);
        }

        if(Object.keys(params).length > 0){
            _this.pg010MainRequest = Object.assign({}, _this.pg010MainRequest, params);
        }
        if (!_this.pg010MainRequest.pageNo){
            if (_this.pg010MainRequest.categoryCd){
                _this.pg010MainRequest.pageNo = 2;
            } else if (_this.pg010MainRequest.sItemNo){
                _this.pg010MainRequest.pageNo = 3;
            } else if (_this.pg010MainRequest.sItemNolP){
                _this.pg010MainRequest.pageNo = 5;
            } else if (_this.pg010MainRequest.customUrl){
                _this.pg010MainRequest.pageNo = "";
            }else {
                _this.pg010MainRequest.pageNo = 1;
            }
        }
        if(queryData.k != undefined && queryData.k != '' && queryData.k != null){
            _this.pg010MainRequest.uuidKokyaku = queryData.k;
        }
        if(queryData.id != undefined && queryData.id != '' && queryData.id != null){
            _this.pg010MainRequest.uuid  = queryData.id;
        }
        _this.pg010MainRequest.ptPageNo != undefined ? _this.ptPageNo = _this.pg010MainRequest.ptPageNo : _this.ptPageNo = null;
        _this.pg010MainRequest.ptPageSize != undefined ? _this.ptPageSize = _this.pg010MainRequest.ptPageSize : _this.ptPageSize = null;
        _this.pg010MainRequest.ptOrderByType != undefined ? _this.ptOrderByType = _this.pg010MainRequest.ptOrderByType : _this.ptOrderByType = null;
        window.addEventListener('scroll', this.handleScroll);
    },
    updated: function(){
        common.setATagStyle(this.linkColor, this.overLinkColor);
    },
    watch: {
        linkColor(val){
            this.$el.style.setProperty('--link-color', val);
        },
        overLinkColor(val){
            this.$el.style.setProperty('--link-over', val);
        }
    },
    destroyed: function() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>
